export default function PrimaryButton({ className = '', disabled, children, ...props }) {
    return (
        <button
            {...props}
            className={
                `relative inline-flex items-center px-4 py-2 lg:px-10 lg:py-4 bg-transparent border border-transparent rounded-btn text-white transition ease-in-out duration-150  hover:bg-none hover:text-primary hover:border-primary overflow-hidden
                before:block before:absolute before:-inset-1 before:bg-gradient-to-r before:from-primary before:to-primary-400 before:to-127% before:-z-0 hover:before:opacity-0 before:transition-opacity
                ${
                    disabled && 'opacity-25'
                } ` + className
            }
            disabled={disabled}
        >
            <div className='inline-flex items-center relative z-5'>{children}</div>
        </button>
    );
}
